import React from 'react'
import { Chart } from './chart'
import { config } from './config'
import './styles.scss'
interface HeatmapProps {
  data: weektype[]
  scalemax?: number
  rechtheightmulti?: number
  inverted?: boolean
  absolute?: boolean
}
export const Heatmap: React.FC<HeatmapProps> = ({
  data,
  scalemax,
  rechtheightmulti,
  inverted,
  absolute
}) => {
  return (
    <div className='Heatmap'>
      <Chart
        data={data}
        scalemax={scalemax}
        rechtheightmulti={rechtheightmulti}
        inverted={inverted}
        absolute={absolute}
      />
    </div>
  )
}
